import "./App.css";
import BgcForm from "./component/BgcForm";

function App() {
  return (
    <div className="App">
      <BgcForm/>
    </div>
  );
}

export default App;
